/**
 * Componente Hidden compatível com MUI v7
 * Replica o comportamento do Hidden do MUI v4 usando useMediaQuery
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@mui/material';
import { useTheme } from 'utils/makeStylesAdapter';

const Hidden = ({
  children,
  only,
  xsUp,
  xsDown,
  smUp,
  smDown,
  mdUp,
  mdDown,
  lgUp,
  lgDown,
  xlUp,
  xlDown,
  implementation = 'js',
  ...other
}) => {
  const theme = useTheme();

  // Breakpoint queries
  const isXsDown = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmDown = useMediaQuery(theme.breakpoints.down('md'));
  const isMdDown = useMediaQuery(theme.breakpoints.down('lg'));
  const isLgDown = useMediaQuery(theme.breakpoints.down('xl'));
  const isXlDown = true;

  const isXsUp = useMediaQuery(theme.breakpoints.up('xs'));
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const isXlUp = useMediaQuery(theme.breakpoints.up('xl'));

  // Only specific breakpoints
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.only('lg'));
  const isXl = useMediaQuery(theme.breakpoints.only('xl'));

  let shouldHide = false;

  // Handle 'only' prop
  if (only) {
    const onlyBreakpoints = Array.isArray(only) ? only : [only];
    shouldHide = onlyBreakpoints.some(bp => {
      switch (bp) {
        case 'xs':
          return isXs;
        case 'sm':
          return isSm;
        case 'md':
          return isMd;
        case 'lg':
          return isLg;
        case 'xl':
          return isXl;
        default:
          return false;
      }
    });
  }

  // Handle directional props
  if (xsUp && isXsUp) shouldHide = true;
  if (xsDown && isXsDown) shouldHide = true;
  if (smUp && isSmUp) shouldHide = true;
  if (smDown && isSmDown) shouldHide = true;
  if (mdUp && isMdUp) shouldHide = true;
  if (mdDown && isMdDown) shouldHide = true;
  if (lgUp && isLgUp) shouldHide = true;
  if (lgDown && isLgDown) shouldHide = true;
  if (xlUp && isXlUp) shouldHide = true;
  if (xlDown && isXlDown) shouldHide = true;

  if (shouldHide) {
    return null;
  }

  return <>{children}</>;
};

Hidden.propTypes = {
  children: PropTypes.node,
  only: PropTypes.oneOfType([
    PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),
  ]),
  xsUp: PropTypes.bool,
  xsDown: PropTypes.bool,
  smUp: PropTypes.bool,
  smDown: PropTypes.bool,
  mdUp: PropTypes.bool,
  mdDown: PropTypes.bool,
  lgUp: PropTypes.bool,
  lgDown: PropTypes.bool,
  xlUp: PropTypes.bool,
  xlDown: PropTypes.bool,
  implementation: PropTypes.oneOf(['js', 'css']),
};

export default Hidden;
